<template>
	<svg viewBox="0 0 24 24">
		<use :href="`#${ name }`" />
	</svg>
</template>

<script>
export default {
	name: 'KkIconBase',
	props: {
		name: {
			type: String,
			required: true,
		},
	},
};
</script>
